module.exports = __webpack_public_path__ + "img/motto-learn-transparent.112c810b.png";